<div class="div full-width" *ngIf="ready" #container>
  <swiper-container autoplay-delay="6000" autoplay-disable-on-interaction="false" loop="true" [slidesPerView]="slidePerView" *ngIf="slidePerView">

    <swiper-slide *ngIf="newsCard?.['trial_suggestion']">
      <app-news-card-item class="full-width" [type]="'trial_suggestion'"></app-news-card-item>
    </swiper-slide>

    <swiper-slide *ngIf="newsCard?.['guest_web_launching']">
      <app-news-card-item class="full-width" [type]="'guest_web_launching'"></app-news-card-item>
    </swiper-slide>
    
    <swiper-slide *ngIf="newsCard?.['whatsapp_launching']">
      <app-news-card-item class="full-width" [type]="'whatsapp_launching'"></app-news-card-item>
    </swiper-slide>

    <swiper-slide *ngIf="newsCard?.['web_checkin_launching']">
      <app-news-card-item class="full-width" [type]="'web_checkin_launching'"></app-news-card-item>
    </swiper-slide>
    
    <!-- <swiper-slide *ngIf="newsCard?.['blast_intro']">
      <app-news-card-item class="full-width" [type]="'blast_intro'" (clickAction)="output($event)"></app-news-card-item>
    </swiper-slide> -->
  
    <swiper-slide *ngIf="newsCard?.['special_promo_voucher']">
      <app-news-card-item class="full-width" [type]="'special_promo_voucher'" (clickAction)="output($event)"></app-news-card-item>
    </swiper-slide>
    
    <swiper-slide *ngIf="newsCard?.['account_voucher']">
      <app-news-card-item class="full-width" [type]="'account_voucher'" (clickAction)="output($event)"></app-news-card-item>
    </swiper-slide>

    <swiper-slide *ngIf="newsCard?.['blast_notice']">
      <app-news-card-item class="full-width" [type]="'blast_notice'"></app-news-card-item>
    </swiper-slide>

    <!-- <swiper-slide *ngIf="newsCard?.['blast_redeem']">
      <app-news-card-item class="full-width" [type]="'blast_redeem'"></app-news-card-item>
    </swiper-slide> -->
  
    <swiper-slide *ngIf="newsCard?.['chrome']">
      <app-news-card-item class="full-width" [type]="'chrome'"></app-news-card-item>
    </swiper-slide>

    <!-- <swiper-slide *ngIf="newsCard?.['theme']">
      <app-news-card-item class="full-width" [type]="'theme'"></app-news-card-item>
    </swiper-slide> -->
    
    <swiper-slide *ngIf="newsCard?.['platform']">
      <app-news-card-item class="full-width" [type]="'platform'"></app-news-card-item>
    </swiper-slide>
    
    <swiper-slide *ngIf="newsCard?.['migrate_gift']">
      <app-news-card-item class="full-width" [type]="'migrate_gift'"></app-news-card-item>
    </swiper-slide>
    
    <swiper-slide *ngIf="newsCard?.['setup_venue']">
      <app-news-card-item class="full-width" [type]="'setup_venue'"></app-news-card-item>
    </swiper-slide>
    
    <swiper-slide *ngIf="newsCard?.['invite_couple']">
      <app-news-card-item class="full-width" [type]="'invite_couple'"></app-news-card-item>
    </swiper-slide>


    
    <swiper-slide *ngIf="newsCard?.['trial_upgrade']">
      <app-news-card-item class="full-width" [type]="'trial_upgrade'"></app-news-card-item>
    </swiper-slide>
    
    <swiper-slide *ngIf="newsCard?.['account_compare']">
      <app-news-card-item class="full-width" [type]="'account_compare'"></app-news-card-item>
    </swiper-slide>
    
    <swiper-slide *ngIf="newsCard?.['account_gift']">
      <app-news-card-item class="full-width" [type]="'account_gift'"></app-news-card-item>
    </swiper-slide>
    
    <swiper-slide *ngIf="newsCard?.['why_premium']">
      <app-news-card-item class="full-width" [type]="'why_premium'"></app-news-card-item>
    </swiper-slide>
    
    <swiper-slide *ngIf="newsCard?.['setup_visitor_page']">
      <app-news-card-item class="full-width" [accountTaskType]="'setup_visitor_page'"></app-news-card-item>
    </swiper-slide>
    
    <swiper-slide *ngIf="newsCard?.['add_guest']">
      <app-news-card-item class="full-width" [accountTaskType]="'add_guest'"></app-news-card-item>
    </swiper-slide>
    
    <swiper-slide *ngIf="newsCard?.['send_qr']">
      <app-news-card-item class="full-width" [accountTaskType]="'send_qr'"></app-news-card-item>
    </swiper-slide>
    
    <swiper-slide *ngIf="newsCard?.['invite_member']">
      <app-news-card-item class="full-width" [accountTaskType]="'invite_member'"></app-news-card-item>
    </swiper-slide>
    
    <swiper-slide *ngIf="newsCard?.['assign_seating']">
      <app-news-card-item class="full-width" [accountTaskType]="'assign_seating'"></app-news-card-item>
    </swiper-slide>
    
    <swiper-slide *ngIf="newsCard?.['review_setting']">
      <app-news-card-item class="full-width" [accountTaskType]="'review_setting'"></app-news-card-item>
    </swiper-slide>
    
    <swiper-slide *ngIf="newsCard?.['checkin_guest']">
      <app-news-card-item class="full-width" [accountTaskType]="'checkin_guest'"></app-news-card-item>
    </swiper-slide>
    
    <swiper-slide *ngIf="newsCard?.['record_gift']">
      <app-news-card-item class="full-width" [accountTaskType]="'record_gift'"></app-news-card-item>
    </swiper-slide>
    
    <swiper-slide *ngIf="newsCard?.['help_center']">
      <app-news-card-item class="full-width" [type]="'help_center'"></app-news-card-item>
    </swiper-slide>
  
    
  </swiper-container>
</div>
<!-- 
<swiper-slide #platform>
  <swiper-slide *ngIf="newsCard?.['platform']">
    <app-news-card-item class="full-width" [type]="'platform'"></app-news-card-item>
  </swiper-slide>
</swiper-slide>

<swiper-slide #migrate_gift>
  <swiper-slide *ngIf="newsCard?.['migrate_gift']">
    <app-news-card-item class="full-width" [type]="'migrate_gift'"></app-news-card-item>
  </swiper-slide>
</swiper-slide>

<swiper-slide #setup_venue>
  <swiper-slide *ngIf="newsCard?.['setup_venue']">
    <app-news-card-item class="full-width" [type]="'setup_venue'"></app-news-card-item>
  </swiper-slide>
</swiper-slide>

<swiper-slide #invite_couple>
  <swiper-slide *ngIf="newsCard?.['invite_couple']">
    <app-news-card-item class="full-width" [type]="'invite_couple'"></app-news-card-item>
  </swiper-slide>
</swiper-slide>

<swiper-slide #account_voucher>
  <swiper-slide *ngIf="newsCard?.['account_voucher']">
    <app-news-card-item class="full-width" [type]="'account_voucher'" (clickAction)="output($event)"></app-news-card-item>
  </swiper-slide>
</swiper-slide>

<swiper-slide #trial_upgrade>
  <swiper-slide *ngIf="newsCard?.['trial_upgrade']">
    <app-news-card-item class="full-width" [type]="'trial_upgrade'"></app-news-card-item>
  </swiper-slide>
</swiper-slide>

<swiper-slide #account_compare>
  <swiper-slide *ngIf="newsCard?.['account_compare']">
    <app-news-card-item class="full-width" [type]="'account_compare'"></app-news-card-item>
  </swiper-slide>
</swiper-slide>

<swiper-slide #account_gift>
  <swiper-slide *ngIf="newsCard?.['account_gift']">
    <app-news-card-item class="full-width" [type]="'account_gift'"></app-news-card-item>
  </swiper-slide>
</swiper-slide>

<swiper-slide #why_premium>
  <swiper-slide *ngIf="newsCard?.['why_premium']">
    <app-news-card-item class="full-width" [type]="'why_premium'"></app-news-card-item>
  </swiper-slide>
</swiper-slide>

<swiper-slide #setup_visitor_page>
  <swiper-slide *ngIf="newsCard?.['setup_visitor_page']">
    <app-news-card-item class="full-width" [accountTaskType]="'setup_visitor_page'"></app-news-card-item>
  </swiper-slide>
</swiper-slide>

<swiper-slide #add_guest>
  <swiper-slide *ngIf="newsCard?.['add_guest']">
    <app-news-card-item class="full-width" [accountTaskType]="'add_guest'"></app-news-card-item>
  </swiper-slide>
</swiper-slide>

<swiper-slide #send_qr>
  <swiper-slide *ngIf="newsCard?.['send_qr']">
    <app-news-card-item class="full-width" [accountTaskType]="'send_qr'"></app-news-card-item>
  </swiper-slide>
</swiper-slide>

<swiper-slide #invite_member>
  <swiper-slide *ngIf="newsCard?.['invite_member']">
    <app-news-card-item class="full-width" [accountTaskType]="'invite_member'"></app-news-card-item>
  </swiper-slide>
</swiper-slide>

<swiper-slide #assign_seating>
  <swiper-slide *ngIf="newsCard?.['assign_seating']">
    <app-news-card-item class="full-width" [accountTaskType]="'assign_seating'"></app-news-card-item>
  </swiper-slide>
</swiper-slide>

<swiper-slide #review_setting>
  <swiper-slide *ngIf="newsCard?.['review_setting']">
    <app-news-card-item class="full-width" [accountTaskType]="'review_setting'"></app-news-card-item>
  </swiper-slide>
</swiper-slide>

<swiper-slide #checkin_guest>
  <swiper-slide *ngIf="newsCard?.['checkin_guest']">
    <app-news-card-item class="full-width" [accountTaskType]="'checkin_guest'"></app-news-card-item>
  </swiper-slide>
</swiper-slide>

<swiper-slide #record_gift>
  <swiper-slide *ngIf="newsCard?.['record_gift']">
    <app-news-card-item class="full-width" [accountTaskType]="'record_gift'"></app-news-card-item>
  </swiper-slide>
</swiper-slide>

<swiper-slide #help_center>
  <swiper-slide *ngIf="newsCard?.['help_center']">
    <app-news-card-item class="full-width" [type]="'help_center'"></app-news-card-item>
  </swiper-slide>
</swiper-slide>

<swiper-slide #blast_redeem>
  <swiper-slide *ngIf="newsCard?.['blast_redeem']">
    <app-news-card-item class="full-width" [type]="'blast_redeem'"></app-news-card-item>
  </swiper-slide>
</swiper-slide> -->
